<template>
  <div>
    <ca-heading text="Lotações" />
    <ca-row>
      <ca-col>
        <ca-button theme="primary" @click="onNew">
          Nova lotação
        </ca-button>
      </ca-col>
    </ca-row>

    <ca-row vertical-offset="2">
      <ca-col>
        <ca-async-content-wrapper
          :on-fetch="getStockings"
          :on-fetch-success="setStockings">
          <ca-table>
            <ca-tr slot="header">
              <ca-th size="5">Código</ca-th>
              <ca-th>Tipo de Lotação</ca-th>
              <ca-th></ca-th>
              <ca-th></ca-th>
            </ca-tr>

            <ca-tr
              v-for="(stock, index) in stockings"
              :key="index"
              @click="onView(stock.id)">
              <ca-td>
                {{ stock.allocationCode }}
              </ca-td>
              <ca-td colspan="2">
                {{ stock.allocationType.description }}
              </ca-td>
              <ca-td>
                <ca-button
                  size="small"
                  class="ca-u-min-margin-right"
                  @click.stop="onEdit(stock.id)">
                  Editar
                </ca-button>
                <ca-button size="small" @click.stop="onDelete(index, stock.id)">
                  Excluir
                </ca-button>
              </ca-td>
            </ca-tr>
          </ca-table>
        </ca-async-content-wrapper>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { getErrorMessageFromResponse } from 'packages/common/utils';
import {
  DELETE_TITLE, DELETE_MESSAGE, DELETE_CONFIRM_TEXT, DELETE_SUCCESS_MESSAGE,
} from './constants';
import { getStockings, setStockings, deleteStock } from './stockingService';
import { EmployerStore } from '../store';

export default {
  name: 'EmployerInformationPage',
  computed: {
    stockings() {
      return EmployerStore.stockings;
    },
  },
  methods: {
    getStockings() {
      return getStockings();
    },
    async setStockings(response) {
      setStockings(response);
    },
    onNew() {
      this.$router.push({ name: 'NewStock' });
    },
    onView(id) {
      this.$router.push({ name: 'ViewStock', params: { id } });
    },
    onEdit(stockId) {
      this.$router.push({ name: 'EditStock', params: { id: stockId } });
    },
    onDelete(index, stockId) {
      this.$caConfirm({
        title: DELETE_TITLE,
        message: DELETE_MESSAGE,
        confirmButtonText: DELETE_CONFIRM_TEXT,
        onConfirm: () => {
          deleteStock(stockId)
            .then(() => {
              this.$toaster.success(DELETE_SUCCESS_MESSAGE);
              this.$delete(this.stockings, index);
            })
            .catch(e => {
              this.$toaster.error(getErrorMessageFromResponse(e));
            });
        },
      });
    },
  },
};
</script>
